import {
    noSearchResults,
    noSearchResultsDetailMessage,
    noSearchResultsInArchiveMailboxResetFolderScopeLink,
    noSearchResultsResetFolderScopeLink,
    searching,
    groupFolderAccessDenied,
    accessDeniedText,
    mailListErrorLinkMessage,
    focusedEmptyStateMessageText,
    focusedEmptyStateLinkMessageText,
    otherEmptyStateMessageText,
    otherEmptyStateLinkMessageText,
    categoryFolderEmpty,
    inboxPivotEmpty,
} from './getDisplayPropertiesForEmptyList.locstring.json';
import {
    inboxIsEmpty,
    draftsIsEmpty,
    flagIsEmpty,
    clearFilter,
    tomeIsEmpty,
    detailTomeIsEmpty,
    unreadIsEmpty,
} from '../strings.locstring.json';
import { loadingFolder } from 'owa-locstrings/lib/strings/loadingfolder.locstring.json';
import { mailListErrorMessage } from 'owa-locstrings/lib/strings/maillisterrormessage.locstring.json';
import { folderIsEmpty } from 'owa-locstrings/lib/strings/folderisempty.locstring.json';
import loc, { format } from 'owa-localize';
import EmptyStateProps from './EmptyStateProps';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import folderStore, {
    ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
    PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID,
} from 'owa-folders';
import selectFocusedViewFilter from 'owa-mail-list-actions/lib/actions/selectFocusedViewFilter';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';
import { clearSearchScope } from 'owa-mail-search';
import { clearSearchScope as clearSearchScopeNext } from 'owa-mail-search-next-lazy';
import { getFolderIdForSelectedNode } from 'owa-mail-folder-forest-store';
import { getIsLightBaseTheme } from 'owa-theme';
import { isFocusedInboxEnabled } from 'owa-mail-list-actions/lib/utils/FocusedInboxUtil';
import { logVerboseUsage, logUsage } from 'owa-analytics';
import { SearchTableQuery } from 'owa-mail-list-search';
import { ActionSource } from 'owa-mail-store';
import { MailListViewState } from 'owa-mail-store/lib/store/schema/MailListViewState';
import { select } from 'satcheljs/lib/legacy';
import { trace } from 'owa-trace';
import {
    getViewFilterForTable,
    LoadErrorStatus,
    TableQuery,
    TableView,
    listViewStore,
    TableQueryType,
    getFocusedFilterForTable,
    getInboxClassificationFilterForTable,
} from 'owa-mail-list-store';
import {
    SearchScopeKind,
    PrimaryMailboxSearchScope,
    ArchiveMailboxSearchScope,
} from 'owa-search-service';
import SearchScenarioId from 'owa-search/lib/store/schema/SearchScenarioId';
import { isInboxPlusEnabled } from 'owa-mail-inbox-plus-store/lib/selectors/inboxPlusFlightUtil';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import inboxPlusStore from 'owa-mail-inbox-plus-store/lib/store/Store';
import { isFeatureEnabled } from 'owa-feature-flags';
import getInboxPlusPivotDisplayProperties from 'owa-mail-inbox-plus-store/lib/selectors/getInboxPlusPivotDisplayProperties';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

let EMPTY_INBOX_SVG;
let EMPTY_FLAGGED_SVG;
let EMPTY_TOME_SVG;
let EMPTY_UNREAD_SVG;
let EMPTY_MENTIONS_SVG;
let EMPTY_ATTACHMENTS_SVG;
let EMPTY_SEARCH_SVG;
let EMPTY_JUNK_SVG;
let EMPTY_DRAFT_SVG;
let EMPTY_DELETED_SVG;
let EMPTY_FOLDER_SVG;
let LOADING_ERROR__SVG;
let ACCESS_ERROR_SVG;

export interface GetMailListEmptyStateState {
    tableView: TableView;
}

/**
 * initialize the svgs icons
 */
function initailizeDisplayIconsForEmptyList() {
    if (getIsLightBaseTheme()) {
        // colored svgs that goes with the blue base theme
        EMPTY_INBOX_SVG = require('owa-empty-state/lib/svg/colored/emptyInbox.svg');
        EMPTY_FLAGGED_SVG = require('owa-empty-state/lib/svg/colored/emptyFlagged.svg');
        EMPTY_TOME_SVG = require('owa-empty-state/lib/svg/colored/emptyToMe.svg');
        EMPTY_UNREAD_SVG = require('owa-empty-state/lib/svg/colored/emptyUnread.svg');
        EMPTY_MENTIONS_SVG = require('owa-empty-state/lib/svg/colored/emptyMentions.svg');
        EMPTY_ATTACHMENTS_SVG = require('owa-empty-state/lib/svg/colored/emptyAttachments.svg');
        EMPTY_SEARCH_SVG = require('owa-empty-state/lib/svg/colored/emptySearch.svg');
        EMPTY_JUNK_SVG = require('owa-empty-state/lib/svg/colored/emptyJunkFolder.svg');
        EMPTY_DRAFT_SVG = require('owa-empty-state/lib/svg/colored/emptyDraftFolder.svg');
        EMPTY_DELETED_SVG = require('owa-empty-state/lib/svg/colored/emptyDeletedItemsFolder.svg');
        EMPTY_FOLDER_SVG = require('owa-empty-state/lib/svg/colored/emptyFolder.svg');
        LOADING_ERROR__SVG = require('owa-empty-state/lib/svg/colored/loadingError.svg');
        ACCESS_ERROR_SVG = require('owa-empty-state/lib/svg/colored/accessError.svg');
    } else {
        // gray scale svgs
        EMPTY_INBOX_SVG = require('owa-empty-state/lib/svg/gray/emptyInbox.svg');
        EMPTY_FLAGGED_SVG = require('owa-empty-state/lib/svg/gray/emptyFlagged.svg');
        EMPTY_TOME_SVG = require('owa-empty-state/lib/svg/gray/emptyToMe.svg');
        EMPTY_UNREAD_SVG = require('owa-empty-state/lib/svg/gray/emptyUnread.svg');
        EMPTY_MENTIONS_SVG = require('owa-empty-state/lib/svg/gray/emptyMentions.svg');
        EMPTY_ATTACHMENTS_SVG = require('owa-empty-state/lib/svg/gray/emptyAttachments.svg');
        EMPTY_SEARCH_SVG = require('owa-empty-state/lib/svg/gray/emptySearch.svg');
        EMPTY_JUNK_SVG = require('owa-empty-state/lib/svg/gray/emptyJunkFolder.svg');
        EMPTY_DRAFT_SVG = require('owa-empty-state/lib/svg/gray/emptyDraftFolder.svg');
        EMPTY_DELETED_SVG = require('owa-empty-state/lib/svg/gray/emptyDeletedItemsFolder.svg');
        EMPTY_FOLDER_SVG = require('owa-empty-state/lib/svg/gray/emptyFolder.svg');
        LOADING_ERROR__SVG = require('owa-empty-state/lib/svg/gray/loadingError.svg');
        ACCESS_ERROR_SVG = require('owa-empty-state/lib/svg/gray/accessError.svg');
    }
}

/**
 * Get the empty list view display properties if user is in search mode
 * @param emptyStateProps the empty state display properties
 * @param tableQuery the table query
 */
async function getEmptyListViewDisplayPropertiesForSearch(
    emptyStateProps: EmptyStateProps,
    tableQuery: TableQuery
) {
    emptyStateProps.icon = EMPTY_SEARCH_SVG;
    emptyStateProps.mainMessage = loc(noSearchResults);
    emptyStateProps.detailMessage = loc(noSearchResultsDetailMessage);

    // Display the option to clean the search folder scope when the selected scope is not a root folder of any mailbox.
    const searchTableQuery = tableQuery as SearchTableQuery;
    const searchScopeKind = searchTableQuery.searchScope.kind;
    if (
        searchScopeKind == SearchScopeKind.PrimaryMailbox ||
        searchScopeKind == SearchScopeKind.ArchiveMailbox
    ) {
        const folderName = folderIdToName(
            (searchTableQuery.searchScope as PrimaryMailboxSearchScope | ArchiveMailboxSearchScope)
                .folderId
        );
        if (
            folderName != PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID &&
            folderName != ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID
        ) {
            emptyStateProps.linkMessage =
                searchScopeKind == SearchScopeKind.ArchiveMailbox
                    ? loc(noSearchResultsInArchiveMailboxResetFolderScopeLink)
                    : loc(noSearchResultsResetFolderScopeLink);
            emptyStateProps.linkCommand = (actionSource: ActionSource) => {
                logUsage('Search_SearchAllFoldersClicked', [SearchScenarioId.Mail]);

                if (isFeatureEnabled('sea-lazy2')) {
                    clearSearchScopeNext(
                        actionSource,
                        true /* shouldStartSearch */,
                        searchScopeKind
                    );
                } else {
                    clearSearchScope(actionSource, true /* shouldStartSearch */, searchScopeKind);
                }
            };

            logUsage('Search_SearchAllFoldersRendered', [SearchScenarioId.Mail]);
        }
    }
}

/**
 * Get the empty state display properties
 * @param showSearchEmptyState whether to show empty state for search
 * @param clearFilterCommand the command that resets the view filter to default view filter
 * @param viewFilter the current view filter
 * @param focusedFilter the focused view filter
 * @param inboxClassificationFilter the inbox classification filter
 * @param tableQuery the table query
 */
function getEmptyStateDisplayProperties(
    showSearchEmptyState: boolean,
    clearFilterCommand: (actionSource: ActionSource) => void,
    viewFilter: ViewFilter,
    focusedFilter: FocusedViewFilter,
    inboxClassificationFilter: InboxClassificationFilter,
    tableQuery: TableQuery
): EmptyStateProps {
    const emptyStateProps: EmptyStateProps = { mainMessage: null };

    if (showSearchEmptyState) {
        getEmptyListViewDisplayPropertiesForSearch(emptyStateProps, tableQuery);
    } else if (viewFilter == 'All') {
        getEmptyListViewDisplayPropertiesForAllFilter(
            getFolderIdForSelectedNode(),
            emptyStateProps,
            focusedFilter,
            inboxClassificationFilter
        );
    } else {
        getEmptyListViewDisplayPropertiesForFilters(
            viewFilter,
            clearFilterCommand,
            emptyStateProps
        );
    }

    return emptyStateProps;
}

/**
 * Calculate the mail list display properties based on the list view state
 * @param tableViewId tableView id
 * @param stateType the mail list view state type
 * @param clearFilterCommand the command that clears view filter
 * @param reloadCommand the command that reloads the selected list view
 */

export default select<GetMailListEmptyStateState>({
    tableView: (tableViewId: string) => listViewStore.tableViews.get(tableViewId),
})(function getDisplayPropertiesForEmptyList(
    tableViewId: string,
    stateType: MailListViewState,
    clearFilterCommand: (actionSource: ActionSource) => void,
    reloadCommand: (actionSource: ActionSource) => void,
    state?: GetMailListEmptyStateState
) {
    let mailListState: EmptyStateProps = { mainMessage: null };
    const tableView = state.tableView;
    const scenarioType = (tableView.tableQuery as SearchTableQuery).scenarioType;
    // For persona scenario we don't want to show search empty state but instead normal folder empty state
    const showSearchEmptyState =
        tableView.tableQuery.type === TableQueryType.Search &&
        scenarioType !== 'persona' &&
        scenarioType !== 'privateDistributionList';
    const isGroup = tableView.tableQuery.type == TableQueryType.Group;
    const viewFilter = getViewFilterForTable(tableView);
    const focusedFilter = getFocusedFilterForTable(tableView);
    const inboxClassificationFilter = getInboxClassificationFilterForTable(tableView.id);

    initailizeDisplayIconsForEmptyList();

    switch (stateType) {
        case MailListViewState.Error:
            mailListState = getDisplayPropertiesForError(
                tableView.loadErrorStatus,
                showSearchEmptyState,
                isGroup,
                reloadCommand
            );
            break;

        case MailListViewState.Loading:
            mailListState = {
                mainMessage: showSearchEmptyState ? loc(searching) : loc(loadingFolder),
                icon: showSearchEmptyState ? EMPTY_SEARCH_SVG : EMPTY_FOLDER_SVG,
            };
            break;

        case MailListViewState.Empty:
            mailListState = getEmptyStateDisplayProperties(
                showSearchEmptyState,
                clearFilterCommand,
                viewFilter,
                focusedFilter,
                inboxClassificationFilter,
                tableView.tableQuery
            );
            break;

        default:
            trace.error('Unrecognized empty state');
            break;
    }

    logVerboseUsage('TnS_MailListEmptyStateShownEvent', [
        stateType,
        showSearchEmptyState,
        viewFilter,
        inboxClassificationFilter,
    ]);

    return mailListState;
});

/**
 * Get the display properties when list view is empty because an error occurred while loading
 * @param error LoadErrorStatus enum
 * @param showSearchError whether to show error for search
 * @param reloadCommand the command that reloads the selected list view
 */
function getDisplayPropertiesForError(
    error: LoadErrorStatus,
    showSearchError: boolean,
    isGroup: boolean,
    reloadCommand: (actionSource: ActionSource) => void
): EmptyStateProps {
    switch (error) {
        case LoadErrorStatus.AccessDenied:
            return {
                mainMessage: isGroup ? loc(groupFolderAccessDenied) : loc(accessDeniedText),
                icon: ACCESS_ERROR_SVG,
            };
        default:
            return {
                mainMessage: loc(mailListErrorMessage),
                icon: LOADING_ERROR__SVG,
                linkMessage: !showSearchError && loc(mailListErrorLinkMessage),
                linkCommand: !showSearchError && reloadCommand,
            };
    }
}

/**
 * Get the display properties when list view is empty and user is in 'All' pivot and in Focused or Other
 * @param focusedFilter focused or other
 * @param inboxId inbox id
 * @param emptyStateProps the state which is used to calculate the mail list display properties
 */
export function getEmptyListViewDisplayPropertiesForAllFiltersFocusedOther(
    focusedViewFilter: FocusedViewFilter,
    inboxId: string,
    emptyStateProps: EmptyStateProps
) {
    const isFocused = focusedViewFilter == FocusedViewFilter.Focused;
    emptyStateProps.icon = EMPTY_INBOX_SVG;

    if (isFocused) {
        const inboxFolder = folderStore.folderTable.get(inboxId);
        emptyStateProps.mainMessage = loc(focusedEmptyStateMessageText);

        if (inboxFolder.TotalCount > 0) {
            emptyStateProps.linkMessage = loc(focusedEmptyStateLinkMessageText);
            emptyStateProps.linkCommand = (actionSource: ActionSource) => {
                selectFocusedViewFilter(FocusedViewFilter.Other, actionSource);
            };
        }
    } else {
        emptyStateProps.mainMessage = loc(otherEmptyStateMessageText);
        emptyStateProps.linkMessage = loc(otherEmptyStateLinkMessageText);
        emptyStateProps.linkCommand = (actionSource: ActionSource) => {
            selectFocusedViewFilter(FocusedViewFilter.Focused, actionSource);
        };
    }
}

/**
 * Get the display properties when list view is empty and user is in 'All' pivot and in a regular folder (not Focused or Other)
 * @param selectedFolderId selected folder id. Can be null if a persona was selected with no associated searchFolder
 * @param emptyStateProps the state which is used to calculate the mail list display properties
 */
function getEmptyListViewDisplayPropertiesForAllFiltersRegularFolders(
    selectedFolderId: string,
    emptyStateProps: EmptyStateProps
) {
    const folderName = selectedFolderId ? folderIdToName(selectedFolderId) : null;
    let mainMessage = loc(folderIsEmpty);
    let icon = EMPTY_FOLDER_SVG;

    switch (folderName) {
        case 'inbox':
            mainMessage = loc(inboxIsEmpty);
            icon = EMPTY_INBOX_SVG;
            break;
        case 'junkemail':
            icon = EMPTY_JUNK_SVG;
            break;
        case 'deleteditems':
            icon = EMPTY_DELETED_SVG;
            break;
        case 'drafts':
            mainMessage = loc(draftsIsEmpty);
            icon = EMPTY_DRAFT_SVG;
            break;
    }

    emptyStateProps.mainMessage = mainMessage;
    emptyStateProps.detailMessage = null;
    emptyStateProps.icon = icon;
}

/**
 * Get the display properties when list view is empty and user is in 'All' pivot
 * @param selectedFolderId selected folder id
 * @param emptyStateProps the state which is used to calculate the mail list display properties
 * @param focusedFilter the focused filter of the table
 * @param inboxClassificationFilter the inbox classification filter of the table
 */
export function getEmptyListViewDisplayPropertiesForAllFilter(
    selectedFolderId: string,
    emptyStateProps: EmptyStateProps,
    focusedFilter: FocusedViewFilter,
    inboxClassificationFilter: InboxClassificationFilter
) {
    let inboxPlusOnlyFocusedOtherEnabled = false;

    if (isInboxPlusEnabled()) {
        const enabledPivots = inboxPlusStore.inboxPlusPivots.filter(pivot => pivot.isEnabled);
        inboxPlusOnlyFocusedOtherEnabled =
            enabledPivots.length === 2 &&
            enabledPivots.filter(
                pivot =>
                    pivot.InboxClassificationFilter === InboxClassificationFilter.Focused ||
                    pivot.InboxClassificationFilter === InboxClassificationFilter.Other
            ).length === 2;
    }

    let isFocusedOther =
        (!isInboxPlusEnabled() &&
            isFocusedInboxEnabled() &&
            focusedFilter !== FocusedViewFilter.None) ||
        inboxPlusOnlyFocusedOtherEnabled;

    if (isFocusedOther) {
        getEmptyListViewDisplayPropertiesForAllFiltersFocusedOther(
            focusedFilter,
            selectedFolderId,
            emptyStateProps
        );
    } else if (
        isInboxPlusEnabled() &&
        folderNameToId('inbox') == selectedFolderId &&
        inboxClassificationFilter !== InboxClassificationFilter.None
    ) {
        getEmptyListViewDisplayPropertiesForInboxPivot(inboxClassificationFilter, emptyStateProps);
    } else {
        getEmptyListViewDisplayPropertiesForAllFiltersRegularFolders(
            selectedFolderId,
            emptyStateProps
        );
    }
}

/**
 * Get the empty state properties based on the view filter
 * @param viewFilter the view filter
 * @param clearFilterCommand the clears filter command
 * @param emptyStateProps the state which is used to calculate the mail list display properties
 */
export function getEmptyListViewDisplayPropertiesForFilters(
    viewFilter: string,
    clearFilterCommand: (actionSource: ActionSource) => void,
    emptyStateProps: EmptyStateProps
) {
    let mainMessage = loc(folderIsEmpty);
    let detailMessage = null;
    let icon = EMPTY_FOLDER_SVG;

    switch (viewFilter) {
        case 'Unread':
            mainMessage = loc(unreadIsEmpty);
            icon = EMPTY_UNREAD_SVG;
            emptyStateProps.linkMessage = loc(clearFilter);
            emptyStateProps.linkCommand = clearFilterCommand;
            break;
        case 'Flagged':
            mainMessage = loc(flagIsEmpty);
            icon = EMPTY_FLAGGED_SVG;
            emptyStateProps.linkMessage = loc(clearFilter);
            emptyStateProps.linkCommand = clearFilterCommand;
            break;
        case 'ToOrCcMe':
            mainMessage = loc(tomeIsEmpty);
            detailMessage = loc(detailTomeIsEmpty);
            icon = EMPTY_TOME_SVG;
            emptyStateProps.linkMessage = loc(clearFilter);
            emptyStateProps.linkCommand = clearFilterCommand;
            break;
        case 'Mentioned':
            icon = EMPTY_MENTIONS_SVG;
            emptyStateProps.linkMessage = loc(clearFilter);
            emptyStateProps.linkCommand = clearFilterCommand;
            break;
        case 'HasAttachment':
            icon = EMPTY_ATTACHMENTS_SVG;
            emptyStateProps.linkMessage = loc(clearFilter);
            emptyStateProps.linkCommand = clearFilterCommand;
            break;

        // Do not display clear filter command for 'UserCategory' view filter
        case 'UserCategory':
            mainMessage = loc(categoryFolderEmpty);
            break;
    }

    emptyStateProps.mainMessage = mainMessage;
    emptyStateProps.detailMessage = detailMessage;
    emptyStateProps.icon = icon;
}

/**
 * Get the empty state properties based on the Inbox pivot
 * @param selectedInboxClassificationFilter the Inbox classification filter
 * @param emptyStateProps the state which is used to calculate the mail list display properties
 */
function getEmptyListViewDisplayPropertiesForInboxPivot(
    selectedInboxClassificationFilter: InboxClassificationFilter,
    emptyStateProps: EmptyStateProps
) {
    const displayText = getInboxPlusPivotDisplayProperties(selectedInboxClassificationFilter)
        .displayText;

    emptyStateProps.mainMessage = format(loc(inboxPivotEmpty), displayText);
    emptyStateProps.detailMessage = null;
    emptyStateProps.icon = EMPTY_INBOX_SVG;
}
